export function ctaAvatars() {
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    document.querySelectorAll('.cta__avatars').forEach((avatarGroup) => {
        const avatars = avatarGroup.querySelectorAll('.cta__avatar');

        if (!avatars.length || prefersReducedMotion) return;

        gsap.fromTo(avatars, {
            autoAlpha: 0,
            y: 32,
            scale: 0,
            transformOrigin: '50% 100%'
        }, {
            autoAlpha: 1,
            y: 0,
            scale: 1,
            duration: 0.75,
            stagger: {
                each: 0.14,
                from: 'center'
            },
            ease: 'back.out(2.5)',
            clearProps: 'transform,opacity,visibility',
            scrollTrigger: {
                trigger: avatarGroup,
                start: 'top 82%',
                once: true
            }
        });
    });
}
